export const paragraphShorten = (paragraph, maxCharacters = 120) => {
  if (!paragraph) return ''
  if (paragraph.length <= maxCharacters) return paragraph

  return paragraph.slice(0, maxCharacters) + ' ...'
}
